export const deprecatedReports = {
  AgeGenderDemographicReport: true,
  's:prdct:target:actv:sum': true,
  's:traffic:sum': true,
  's:segmentation:sum': true,
  's:pla:offer:perf': true,
};

